import clsx from 'clsx';
import PropTypes from 'prop-types';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import FormField from 'ui/molecules/FormField/FormField';
import IconBubble from 'ui/molecules/IconBubble/IconBubble';
import TextArea from 'ui/atoms/TextArea/TextArea';
import React from 'react';

function DialogStudentFeedback({ t, open, onClose, goodFeedback, badFeedback, onSuccess }) {
  return (
    <Dialog
      className="dialog-student-feedback"
      isOpen={open}
      title={
        <div className="dialog-student-feedback__header-left">
          <IconBubble name="flag" background="orange-primary" /> <div className="dialog-student-feedback__header-title">{t('assigments:Feedback')}</div>
        </div>
      }
      onClose={onClose}
      onSuccess={onSuccess}
      size="m"
    >
      <div className="dialog-student-feedback__content">
        <div className="dialog-feed-back__container">
          <div className={clsx('dialog-feed-back__textarea-container', { 'dialog-feed-back__textarea-container--good': goodFeedback })}>
            <div className="dialog-feed-back__textarea-header">
              <IconBubble name="flame" background={goodFeedback ? 'green' : 'gray'} />
              <span className="dialog-feed-back__textarea-title">{t('assigments:Things that are done very well')}</span>
            </div>
            <FormField isDisabled isLabelHidden label={t('assigments:Things that are done very well')}>
              <TextArea placeholder={t('assigments:There are no feedback yet on what you have done well')} value={goodFeedback} />
            </FormField>
          </div>
          <div className={clsx('dialog-feed-back__textarea-container', { 'dialog-feed-back__textarea-container--bad': badFeedback })}>
            <div className="dialog-feed-back__textarea-header">
              <IconBubble name="thumb_up" background={badFeedback ? 'orange' : 'gray'} />
              <span className="dialog-feed-back__textarea-title">{t('assigments:Things that can be improved')}</span>
            </div>
            <FormField isDisabled isLabelHidden label={t('assigments:Things that can be improved')}>
              <TextArea placeholder={t('assigments:There are no feedback yet on what you can to improve')} value={badFeedback} />
            </FormField>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

DialogStudentFeedback.propTypes = {
  t: PropTypes.func,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  goodFeedback: PropTypes.string,
  badFeedback: PropTypes.string,
  onSuccess: PropTypes.func,
};

export default DialogStudentFeedback;
